function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.25063 6.67215H22.1792C22.356 6.67215 22.5006 6.52751 22.5006 6.35073V4.10073C22.5006 3.92394 22.356 3.7793 22.1792 3.7793H2.25063C2.07384 3.7793 1.9292 3.92394 1.9292 4.10073V6.35073C1.9292 6.52751 2.07384 6.67215 2.25063 6.67215ZM33.7506 12.2972H2.25063C2.07384 12.2972 1.9292 12.4418 1.9292 12.6186V14.8686C1.9292 15.0454 2.07384 15.19 2.25063 15.19H33.7506C33.9274 15.19 34.0721 15.0454 34.0721 14.8686V12.6186C34.0721 12.4418 33.9274 12.2972 33.7506 12.2972Z",
  fill: "#646464"
});

var SvgAlignLeftShort = (_ref) => {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlignLeftShort, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/align-left-short.aaddd4b4.svg";
export { ForwardRef as ReactComponent };